import React from 'react';
import BSOverlay from '../../../_utils/bs-overlay';
import Failures from '../../../_photo-loader/failures';
import { builderDispatch, WebUI } from '../../../_utils/ui';

class PrintsBuilderPhotoAlbumDirectLoader {
  constructor(uploadUrl, onBegunUploading, onUploaded, onDone) {
    this._uploadUrl = uploadUrl;
    this._onBegunUploading = onBegunUploading;
    this._onUploaded = onUploaded;
    this._onDone = onDone;

    this._pollInterval = 5000;
    this._doneHash = {};

    builderDispatch.register((payload) => {
      switch (payload.type) {
        case WebUI.UPLOAD_ABORTED:
        case WebUI.PHOTO_EVENT_REMOVE_PRINTS_CONFIRM:
          this._clearInterval();
          break;
      }
    });
  }

  slingshot(photoIds, albumIds = []) {
    const formData = new FormData();
    photoIds.forEach((id) =>
      formData.append('upload_from_gallery_photo_ids[]', id),
    );
    albumIds.forEach((id) =>
      formData.append('upload_from_gallery_album_id[]', id),
    );
    formData.append('source', 'albums');

    fetch(this._uploadUrl, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest', // in order for request.xhr? to be true
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Add the albums-import token to the current URL for reload resilience.
        // Using searchParams.set preserves any other query params already in the URL.
        if (window.history) {
          try {
            const token = new URL(
              data.urls.prints_builder,
              window.location.origin,
            ).searchParams.get('albums-import');
            if (token) {
              const url = new URL(window.location.href);
              url.searchParams.set('albums-import', token);
              window.history.replaceState({}, '', url.toString());
            }
          } catch {
            /* ignore */
          }
        }

        this.listen(data.urls.listener);
      });
  }

  listen(url) {
    perform.call(this, true);

    this._pollingIntervalID = setInterval(
      perform.bind(this),
      this._pollInterval,
    );

    function perform(firstRun) {
      fetch(url, {
        credentials: 'same-origin',
      })
        .then((response) => response.json())
        .then((data) => this._processPollResponse(data, firstRun))
        .catch(() => {
          this._clearInterval();
        });
    }
  }

  _processPollResponse(response, firstRun = false) {
    if (firstRun) {
      this._onBegunUploading(response.total);
    }

    (response.images || []).forEach((image) => {
      if (this._doneHash.hasOwnProperty(image.image_id)) {
        return;
      }

      this._onUploaded(image, 'albums');
      this._doneHash[image.image_id] = image.image_id;
    });

    if (response.complete) {
      this._clearInterval();

      // Import complete, clear albums-import URL query param
      if (window.history) {
        const url = new URL(window.location.href);
        url.searchParams.delete('albums-import');
        window.history.replaceState({}, '', url.toString());
      }

      if (response.failures) {
        this._showErrorModal(response);
      } else {
        this._onDone((response.images || []).length, 0);
      }
    }
  }

  cancel() {
    this._clearInterval();
  }

  _clearInterval() {
    clearInterval(this._pollingIntervalID);
    this._pollingIntervalID = null;
  }

  _showErrorModal({ failures }) {
    const $modal = (
      <BSOverlay show onHide={handleIgnore}>
        <Failures
          numberOfFailures={failures.length}
          shouldRetry
          onIgnore={handleIgnore.bind(this)}
          onRetry={handleRetry.bind(this)}
        />
      </BSOverlay>
    );

    $('body').append('<div id="direct-album-loader-error" />');

    ReactDOM.render(
      $modal,
      document.getElementById('direct-album-loader-error'),
    );

    function handleIgnore() {
      builderDispatch.dispatch({
        type: WebUI.UPLOAD_ABORTED,
      });

      remove();
    }

    function handleRetry() {
      this.slingshot(failures.map((failure) => failure.id));

      remove();
    }

    function remove() {
      $('#direct-album-loader-error, .modal-backdrop').remove();
    }
  }
}

export default PrintsBuilderPhotoAlbumDirectLoader;
